import { Box } from "@chakra-ui/react";

const CatalogPdf = () => {
  return (
    <Box height={"80vh"}>
      <iframe
        src="https://online.flippingbook.com/view/634839737/"
        width={"100%"}
        height={"100%"}
      ></iframe>
    </Box>
  );
};

export default CatalogPdf;
